var map = {
	"./calentadores.png": "c888",
	"./calentadores_olc.png": "23cbb",
	"./climas.png": "de36",
	"./climas_old.png": "17a3a",
	"./iluminacion.png": "61be",
	"./paneles_old.png": "f702",
	"./refrigeracion.png": "6fc4",
	"./solares.png": "67f4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b21b";